import React from 'react';
import { usePageMeta } from '../../hooks/usePageMeta';

interface ErrorPageProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ error, resetErrorBoundary }) => {
  const metaData = usePageMeta('Error');
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      {metaData}
      <div className="p-6 bg-white shadow-lg rounded-lg border border-gray-300 max-w-md">
        <h1 className="text-2xl font-bold text-red-600">Oops! Something went wrong.</h1>
        <p className="mt-4 text-gray-800">{error.message}</p>
        <details className="mt-4 p-2 bg-gray-100 border border-gray-200 rounded-md">
          <summary className="font-semibold cursor-pointer text-gray-700">Error Details</summary>
          <p className="mt-2 text-sm text-gray-600">{error.stack}</p>
        </details>
        <button
          onClick={resetErrorBoundary}
          className="mt-6 w-full py-2 bg-meta-5 text-white font-semibold rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;
